import React from 'react'

import {Colors, Icon, P, Row} from '../../src/components/UI/index.js'

/**
 * The (first) original address of a retour: the address the order is returned from, no longer a stop itself.
 */
export default function OriginalAddressRow({address, style}) {
    return (
        <Row style={{alignItems: 'center', ...style}}>
            <Icon style={{marginRight: 6, fontSize: 20, color: Colors.retour}} icon='mdi mdi-keyboard-return' />

            <P ellipsis style={{color: Colors.textMedium}}>
                {'Retour van: '}
                <span translate='no'>{`${address.name ? `${address.name}, ` : ''}${address.street} ${address.nr}${address.addition} ${address.city}`}</span>
            </P>
        </Row>
    )
}
